import React, { useState } from 'react';
import SessionManager from '../../routes/SessionManager';
import Toastr from 'toastr';
import { Collapse, notification } from 'antd';
import mapMarkerIcon from '../../assets/img/map-marker.png';
import $ from 'jquery';
import states_polygon_map from '../../config/us-map.json';
import GoogleMapForSiteSupt from './GoogleMapForSiteSupt';
import { Polygon, Marker, InfoWindow } from '@react-google-maps/api';
import CommonUtils from '../../util/CommonUtils';

const SitesHawkEye = (props) => {

    let sessionManager = new SessionManager();
    let user = sessionManager.readCookie('user');
    let getStatesFound = () => {
        let sites_statewise = {};
        for (let site of user.site_locations) {
            if (!sites_statewise[site.site_stateprov])
                sites_statewise[site.site_stateprov] = [];
            sites_statewise[site.site_stateprov].push(site);
        }
        return sites_statewise;
    };
    const [site_stateprov, setSiteStateProv] = useState(null);
    const [site_stateprov_name, setSiteStateProvName] = useState("United States");
    const [site_filter, setSiteFilter] = useState(null);
    const [info_window, setInfoWindow] = useState(null);
    let states = getStatesFound();

    let onSiteClick = async (s, redirect, desc) => {
        await CommonUtils.setSiteSelected(s);
        if (redirect === "timelapse-dashboard") {
            notification['success']({
                duration: 3,
                top: 100,
                message: 'Info',
                description: `Redirecting you to ${desc} page.`,
                onClose: () => { window.location = `/${redirect}`; }
            });
        } else {
            setTimeout(() => {
                window.location = `/${redirect}`
            }, 1000);
        }
    }

    let onStateProvinceClick = (s) => {
        let obj = {};
        if (s === undefined || s === null) {
            obj = { site_stateprov: null, site_stateprov_name: 'United States', site_color: '' };
        } else {
            obj = { site_stateprov: s.stateprov, site_stateprov_name: s.name, site_color: s.color }
        }
        setSiteFilter(null);
        setInfoWindow(null);
        setSiteStateProv(obj.site_stateprov);
        setSiteStateProvName(obj.site_stateprov_name);
    }

    let toggleInfoWindow = (prop) => {
        let p = info_window;
        let i = (p === undefined || p === null) ? prop : null;
        setInfoWindow(i);
    }

    let filterSite = (s) => {
        Toastr.clear();
        if (s.site_geolocation && s.site_geolocation.trim() !== "" && s.site_geolocation.trim() !== "0,0") {
            let site_filters = site_filter && site_filter.site_id === s.site_id ? null : s;
            let extraAtts = {};
            if (site_filters) {
                let p = states_polygon_map[s.site_stateprov];
                extraAtts = { site_stateprov: p.stateprov, site_stateprov_name: p.name, site_color: p.color }
            }
            setSiteFilter(site_filters);
            setSiteStateProv(extraAtts.site_stateprov);
            setSiteStateProvName(extraAtts.site_stateprov_name);
            setInfoWindow(null);
        } else {
            Toastr.error('Please contact SiteSupt Support to update geo location for ' + s.site_name + '.', 'GeoLocation Not Found !');
        }
    }
    //console.log(state);
    $('#site_stateprov_name').html(site_stateprov_name || "United States");

    const icon = {
        url: mapMarkerIcon,
        anchor: { x: 32, y: 32 },
        scaledSize: { width: 38, height: 40 }
    };

    let markers = [];
    let polygons = [];
    let center;

    let zoomLevel = site_stateprov !== null ? 5.5 : 4;
    let siteFilter = site_filter;
    let latlngs = [];

    let filterStates = site_stateprov ? { [site_stateprov]: 1 } : states;
    if (!site_filter) {
        for (let s in states_polygon_map) {
            if (!filterStates[s])
                continue;
            let p = states_polygon_map[s];
            center = { lat: p.polygon[0].lat, lng: p.polygon[0].lng };
            latlngs.push({ lat: p.polygon[0].lat, lng: p.polygon[0].lng });

            polygons.push(<Polygon
                path={p.polygon}
                key={s}
                options={{
                    fillColor: p.color,
                    fillOpacity: 0.4,
                    strokeColor: "#000",
                    strokeOpacity: 1,
                    strokeWeight: 1
                }}
                onClick={() => onStateProvinceClick(p)} />)
        }
    }

    if (siteFilter)
        zoomLevel = 15;

    if (site_stateprov) {
        latlngs = [];
        for (let site of states[site_stateprov]) {

            if (siteFilter && siteFilter.site_id !== site.site_id)
                continue;

            let latlang = site.site_geolocation ? site.site_geolocation.split(',') : null;
            let latLng = latlang ? new window.google.maps.LatLng(latlang[0], latlang[1]) : null;

            if (latLng) {
                center = latLng;
                latlngs.push({ lat: latlang[0], lng: latlang[1] });
                if (props.dropdown) {
                    let marker = <Marker
                        onClick={() => { toggleInfoWindow('info_' + site.site_name) }}
                        position={latLng}
                        icon={icon}
                        key={'marker_' + site.site_name}
                        label={{ text: site.site_name, color: 'yellow' }}
                    >
                        {info_window === ('info_' + site.site_name) &&
                            <InfoWindow position={new window.google.maps.LatLng(latlang[0], latlang[1])}>
                                <>
                                    <div className="dropdown" tabIndex="0">
                                        {CommonUtils.hasPermission('SITESUPT-UI-DASHBOARD-SITES') && <button className="dropdown-item " tabIndex="-1" onClick={() => onSiteClick(site, "dashboard")}>Dashboard</button>}
                                        <button className="dropdown-item" tabIndex="-1" onClick={() => onSiteClick(site, "sensors-dashboard")}>Sensors Dashboard</button>
                                        {CommonUtils.hasPermission('SITESUPT-UI-DASHBOARD-SITEMAP') && <button className="dropdown-item" tabIndex="-1" onClick={() => onSiteClick(site, "sitemap")}>Site Map</button>}
                                        {CommonUtils.hasPermission('SITESUPT-UI-SITE-MGMT') && <button className="dropdown-item" tabIndex="-1" onClick={() => onSiteClick(site, "site-management")}>Site Management</button>}
                                        {CommonUtils.hasPermission('SITESUPT-UI-BIM-VIEWER') && <button className="dropdown-item" tabIndex="-1" onClick={() => onSiteClick(site, "bim-models")}>BIM Viewer</button>}
                                        {CommonUtils.hasPermission('SITESUPT-UI-REPORTS') && <button className="dropdown-item" tabIndex="-1" onClick={() => onSiteClick(site, "reports")}>Reports</button>}
                                        {CommonUtils.hasPermission('SITESUPT-UI-VIDEOS') && <button className="dropdown-item" tabIndex="-1" onClick={() => onSiteClick(site, "videos")}>Videos</button>}
                                    </div>
                                </>
                            </InfoWindow>
                        }
                    </Marker>
                    markers.push(marker);
                } else {
                    let marker = <Marker
                        onMouseOver={() => { toggleInfoWindow('info_' + site.site_name) }}
                        onMouseOut={() => { toggleInfoWindow('info_' + site.site_name) }}
                        position={latLng}
                        onClick={() => onSiteClick(site, "timelapse-dashboard", "Timelapse Dashboard")}
                        icon={icon}
                        key={'marker_' + site.site_name}
                        label={info_window === ('info_' + site.site_name) ? { text: site.site_name, color: 'yellow' } : ''}
                    >
                    </Marker>
                    markers.push(marker);
                }

                //fitBounds.extend({ lat: parseFloat(latlang[0]), lng: parseFloat(latlang[1]) });
            }
        }
    }
    let siteHighlighterCSS = ["text-primary p-2 cursor-pointer", "p-2 cursor-pointer"];

    let filtered_states_list = site_stateprov ? { [site_stateprov]: 1 } : states;
    filtered_states_list = states; // For now lets show all states in accordion.

    let state_keys = [...Object.keys(filtered_states_list)].sort();
    if (site_stateprov && state_keys.includes(site_stateprov)) {
        state_keys.splice(state_keys.indexOf(site_stateprov), 1);
        state_keys.unshift(site_stateprov);
    }

    setTimeout(() => { $('.dismissButton').trigger('click'); }, 2000);
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-12">
                    <h6 className="bold text-app">Portfolio</h6>
                    <label>{site_stateprov_name}</label>
                </div>
            </div>
            <div className="row">
                <div className="col-md-10">
                    <GoogleMapForSiteSupt center={center} latlngs={latlngs} style={{ height: '78vh', width: '100%' }} zoom={zoomLevel} markers={markers} polygons={polygons}></GoogleMapForSiteSupt>
                    {site_stateprov &&
                        <button style={{ position: 'absolute', top: '10px', left: '11.5rem' }} className="btn btn-sm btn-primary pull-right" onClick={() => onStateProvinceClick(undefined)}>
                            <i className="fa fa-globe-americas"></i> Show States
                        </button>
                    }
                </div>
                <div className="col-md-2" id="sites_mapview">
                    <Collapse accordion activeKey={site_stateprov} expandIconPosition="end" onChange={(e) => onStateProvinceClick(states_polygon_map[e])}>
                        {filtered_states_list && state_keys.map(k => (
                            <React.Fragment key={states_polygon_map[k].stateprov}>
                                <Collapse.Panel header={states_polygon_map[k].name} key={states_polygon_map[k].stateprov} >
                                    <ul className={"list-group " + states_polygon_map[k].stateprov} >
                                        {filtered_states_list[k].map((s) => (
                                            <li
                                                key={s.site_id}
                                                onClick={() => filterSite(s)}
                                                style={{ listStyle: "none" }}
                                                className={siteFilter && siteFilter.site_id === s.site_id ? siteHighlighterCSS[0] : siteHighlighterCSS[1]}
                                            >
                                                <i className={"fa fa-map-marker-alt " + ((s.site_geolocation && s.site_geolocation.trim() !== "" && s.site_geolocation.trim() !== "0,0") ? "text-danger" : "text-gray")}></i> &nbsp; {s.site_name}
                                            </li>
                                        ))}
                                    </ul>
                                </Collapse.Panel>
                                {site_stateprov === k && <div style={{ background: '#e6e6e6' }}>&nbsp;</div>}
                            </React.Fragment>
                        ))}
                    </Collapse>
                </div>
            </div>
        </React.Fragment >
    );
}

export default SitesHawkEye;